import { render, staticRenderFns } from "./landingPage.vue?vue&type=template&id=3af470f4&scoped=true"
import script from "./landingPage.vue?vue&type=script&lang=js"
export * from "./landingPage.vue?vue&type=script&lang=js"
import style0 from "./landingPage.vue?vue&type=style&index=0&id=3af470f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3af470f4",
  null
  
)

export default component.exports